const locale = {
	// #region User Dashboard
	WELCOME: 'Welcome back',
	PROFILE_LINK: 'Go to your profile ',

	PERSONAL_AREA: 'Personal area',

	USER_LOGIN_EMAIL: 'Login Email Address',
	USER_RECRUITMENT_DATE: 'Recruitment date',
	RIGHTSIDEBAR_INFO_SECTION: 'Information',
	RIGHTSIDEBAR_NOTIFICATION_SECTION: 'Notification',
	RIGHTSIDEBAR_GROUPS_SECTION: 'Groups',
	RIGHTSIDEBAR_SETTINGS_SECTION: 'Settings',

	USER_MENU_EDIT_PROFILE: 'Edit profile',
	USER_MENU_ADMIN_AREA: 'Go to Admin area',
	USER_MENU_CHANGE_PASSWORD: 'Change password',

	DIALOG_USERPROFILE_AVATAR: 'Avatar',
	DIALOG_USERPROFILE_SECTION_PERCEPTIVE_TITLE: 'Edit Perceptive Account details',
	DIALOG_USERPROFILE_SECTION_PROFILE_TITLE: 'Edit profile details',
	// #endregion

	// #region Pages title and helper texts
	MODULE_COMMUNICATIONS_TITLE: 'Communications',
	MODULE_DOCS_TITLE: 'Documents',
	MODULE_REQUESTS_TITLE: 'Requests',
	MODULE_LEAVE_TITLE: 'Leave',
	MODULE_AVAILABILITY_TITLE: 'Users Availability',
	MODULE_AVAILABILITY_GROUP_TITLE: 'Members Availability',
	PAGE_SUPERVISOR_LEAVE_TITLE: 'Supervisors - Leave',
	PAGE_SUPERVISOR_CALENDAR_TITLE: 'Supervisors - Calendar',
	PAGE_GROUP_INFO_TITLE: 'Informations',
	// #endregion

	// #region User Availability texts
	USER_AVAILABLE: 'Available',
	USER_AWAY: 'Business Trip',
	USER_NOT_AVAILABLE: 'Not Available',
	SMARTWORKING: 'Smartworking',
	USER_REDUCED_AVAILABILITY: 'Reduced availability',
	SATURDAY: 'Saturday',
	SUNDAY: 'Sunday',
	CLOSING_DAY: 'Closing day',
	// #endregion

	// #region Calendar texts
	CALENDAR_BUTTON_REJECT: 'Reject',
	CALENDAR_BUTTON_ACCEPT: 'Accept',
	CALENDAR_BUTTON_BACK: 'Back',
	CALENDAR_DIALOG_REJECT_TITLE: 'Reject',

	CALENDAR_TOOLTIP_TODAY: 'Today',
	CALENDAR_TOOLTIP_DAY: 'Day',
	CALENDAR_TOOLTIP_WEEK: 'Week',
	CALENDAR_TOOLTIP_MONTH: 'Month',
	CALENDAR_TOOLTIP_PREVIOUS: 'Previous',
	CALENDAR_TOOLTIP_NEXT: 'Next',
	// #endregion

	// #region Misc
	PAGE_GROUP_INFO_MEMBERS: 'Members',

	NO_NOTIFICATIONS: 'There are no notifications to read.',

	NO_COMMUNICATIONS_TITLE: 'No Communications available',
	NO_COMMUNICATIONS_DESCRIPTION: 'There are no active Communications visible for the current User.',

	NO_DOCSFOLDERS_TITLE: 'No Documents Folder available',
	NO_DOCSFOLDERS_DESCRIPTION: 'There are no Documents Folders visible for the current User.'
	// #endregion
};

export default locale;
